// Config service: unified access to runtime (window.__APP_CONFIG__) and build-time (import.meta.env)

export class AppConfigService {
  static getString(
    key: string,
    options?: { required?: boolean; pattern?: RegExp }
  ): string | undefined {
    // 1) Runtime (browser) via window.__APP_CONFIG__
    if (typeof window !== "undefined") {
      const runtimeVal = (window as any)?.__APP_CONFIG__?.[key];
      if (typeof runtimeVal === "string" && runtimeVal.trim()) {
        if (options?.pattern && !options.pattern.test(runtimeVal)) {
          console.warn(`[config] ${key} does not match pattern at runtime`);
        } else {
          return runtimeVal;
        }
      }
    }

    // 2) Build-time via import.meta.env
    const viteVal = (import.meta as any)?.env?.[key] as string | undefined;
    if (typeof viteVal === "string" && viteVal.trim()) {
      if (options?.pattern && !options.pattern.test(viteVal)) {
        console.warn(`[config] ${key} does not match pattern at build time`);
      } else {
        return viteVal;
      }
    }

    if (options?.required) {
      console.error(`[config] missing required key: ${key}`);
    }
    // from env
    const envVal = import.meta.env[key];
    if (envVal) {
      return envVal;
    }
    return undefined;
  }

  static getUrl(
    key: string,
    options?: { required?: boolean }
  ): string | undefined {
    return this.getString(key, {
      required: options?.required,
      pattern: /^https?:\/\//,
    });
  }
}
